<template>
  <info-header-card :icon="laboratory.icon()" :header="header" :rows="rows" />
</template>

<script>
import InfoHeaderCard from "@/components/shared/InfoHeaderCard";
import LaboratoryModel from "@/models/lab/LaboratoryModel";
export default {
  name: "LaboratoryCard",
  components: {
    InfoHeaderCard
  },
  props: {
    laboratory: {
      type: Object,
      default: () => new LaboratoryModel()
    }
  },
  computed: {
    header() {
      return this.laboratory.name;
    },
    rows() {
      return [
        {
          label: "Lab Code",
          value: this.laboratory.code
        },
        {
          label: "Legal Name",
          value: this.laboratory.legal_name
        },
        {
          label: "GST Number",
          value: this.laboratory.gst_number
        },
        {
          label: "Description",
          value: this.laboratory.description
        }
      ];
    }
  }
};
</script>
